const CHINA_TZ_OFFSET_MS = 8 * 60 * 60 * 1000;

const toChinaDate = (value?: string | Date | null) => {
  if (!value) {
    return null;
  }

  const parsed = value instanceof Date ? new Date(value) : new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }

  return new Date(parsed.getTime() + CHINA_TZ_OFFSET_MS);
};

const pad2 = (value: number) => `${value}`.padStart(2, '0');

export const formatChinaDateTime = (value?: string | Date | null) => {
  const chinaDate = toChinaDate(value);
  if (!chinaDate) {
    return '';
  }

  const year = chinaDate.getUTCFullYear();
  const month = pad2(chinaDate.getUTCMonth() + 1);
  const day = pad2(chinaDate.getUTCDate());
  const hour = pad2(chinaDate.getUTCHours());
  const minute = pad2(chinaDate.getUTCMinutes());
  const second = pad2(chinaDate.getUTCSeconds());
  return `${year}年${month}月${day}日 ${hour}:${minute}:${second}`;
};

export const formatChinaMonthDayTime = (value?: string | Date | null) => {
  const chinaDate = toChinaDate(value);
  if (!chinaDate) {
    return '';
  }

  const month = chinaDate.getUTCMonth() + 1;
  const day = chinaDate.getUTCDate();
  const hour = pad2(chinaDate.getUTCHours());
  const minute = pad2(chinaDate.getUTCMinutes());
  return `${month}月${day}日 ${hour}:${minute}`;
};

export const formatChinaTime = (value?: string | Date | null) => {
  const chinaDate = toChinaDate(value);
  if (!chinaDate) {
    return '';
  }

  return `${pad2(chinaDate.getUTCHours())}:${pad2(chinaDate.getUTCMinutes())}`;
};

export const toChinaDateKey = (value?: string | Date | null) => {
  const chinaDate = toChinaDate(value);
  if (!chinaDate) {
    return '';
  }

  return `${chinaDate.getUTCFullYear()}-${pad2(chinaDate.getUTCMonth() + 1)}-${pad2(chinaDate.getUTCDate())}`;
};
